import { DeviceStatusInfo } from "@fairfleet/geotab";
import { UseQueryResult, keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

// Hook für die Abfrage eines einzelnen Fahrzeugs (Detailansicht)
export function useStatusInfoById(
  id: string,
  diagnosticIds: string[] = [],
  interval?: number,
): UseQueryResult<DeviceStatusInfo | null> {
  const queryClient = useQueryClient();

  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["DeviceStatusInfo", activeSessionId, id, diagnosticIds],

    queryFn: async ({ signal }) => {
      // Abfrage für ein einzelnes Fahrzeug
      const result = await geotabClient.get(
        "DeviceStatusInfo",
        { deviceSearch: { id }, diagnostics: diagnosticIds.map(id => ({ id })) },
        1,
        signal,
      );
      const latestStatus: DeviceStatusInfo | null = result?.[0] ?? null;
      if (latestStatus) {
        queryClient.setQueryData(["DeviceStatusInfo", activeSessionId, id], latestStatus);
      }
      return latestStatus;
    },

    refetchInterval: interval ?? 8000,
    refetchIntervalInBackground: true,
    placeholderData: keepPreviousData,
    // gcTime: 60000,
    // staleTime: 5000,
    enabled: !!id,

    initialData: () => {
      const statusMapEntries = queryClient.getQueriesData<Record<string, DeviceStatusInfo>>({
        queryKey: ["DeviceStatusInfo", activeSessionId],
        exact: false,
      });

      for (const [, data] of statusMapEntries) {
        if (data?.[id]) {
          return data[id];
        }
      }
    },
  });
}
